import script from "./AltLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AltLogin.vue?vue&type=script&setup=true&lang=js"

import "./AltLogin.vue?vue&type=style&index=0&id=2c417344&lang=css"

const __exports__ = script;

export default __exports__